import otherChildEditionIds from '@/services/http/api/otherChildEditionIds'

export default {
  namespaced: true,
  state: {
    loader: null,
    otherChildEditionIds: null
  },
  getters: {
    getLoader: (state) => state.loader,
    getOtherChildEditionIds: (state) => state.otherChildEditionIds
  },
  mutations: {
    setLoader(state, payload) {
      state.loader = payload
    },
    setOtherChildEditionIds(state, payload) {
      state.otherChildEditionIds = payload
    },
    clear(state) {
      state.loader = null
      state.otherChildEditionIds = null
    }
  },
  actions: {
    getOtherChildEditionIds({ commit, dispatch }, payload) {
      if (Number.isInteger(Number(payload?.childEditionId)) === false) {
        const error = new Error('invalid child edition id')
        error.response = { status: 404 }
        return Promise.reject(error)
      }
      commit('setLoader', true)

      return otherChildEditionIds
        .get(payload, payload?.getAssignedFirst)
        .then(({ data }) => {
          commit('setOtherChildEditionIds', data?.data || null)
          return data?.data
        })
        .catch((error) => {
          if (
            error?.response?.status === 403 &&
            payload?.getAssignedFlag &&
            !payload?.getAssignedFirst
          ) {
            dispatch('getOtherChildEditionIds', { ...payload, getAssignedFirst: true })
          }
        })
        .finally(() => {
          commit('setLoader', false)
        })
    }
  }
}
